
import { Box, VStack } from '@chakra-ui/react';
import { Infobox } from 'Atoms';
import { Typography } from 'Tokens';
const Header = ({
                    title = 'Disclosure Requirements',
                    showInfobox = false,
                    infoboxDescription = '',
                }: {
    title?: string;
    showInfobox?: boolean;
    infoboxDescription?: string;
}) => {
    return (
        <VStack spacing="16px" alignItems="start" w="100%">
            <Box w="100%" borderBottom="1px solid" borderColor="border.decorative" pb="8px">
                <Typography variant="h3">{title}</Typography>
            </Box>

            {showInfobox && (
                <Box w="100%">
                    <Infobox
                        status="neutral"
                        withIcon={false}
                        description={infoboxDescription}
                        closable={false}
                    />
                </Box>
            )}
        </VStack>
    );
};

export default Header;
